module.exports = __webpack_public_path__ + "assets/img/spirit-type.1a5493a1.svg";